<template>
  <div class="view-container">
    <div class="card">
      <div class="segment-block">
        <a-segmented v-model:value="selectedFilter" :options="filterTypes" />
      </div>

      <div class="course-list">
        <div v-if="tableData && tableData.length">
          <div v-if="selectedFilter === 'Карточками'" class="course-card-list">
              <a-card v-for="(course, key) in courseActivity" :key="course.id + '_' + key" class="course-card">
                <div class="card-image-link">
                  <img :src="Math.random() < 0.5 ? coverA : coverB" alt="обложка курса">
                </div>
                <div>
                  <div class="course-tag-wrapper">
                    <a-tag v-if="course.status === 'finished'">Завершен</a-tag>
                    <a-tag class="{{ course.remaining_days > 7 ?  'blue-tag' : 'red-tag'}}" v-else-if="course.access_expired_at">Завершите до {{ course.access_expired_at }}</a-tag>
                    <a-tag>Завершен</a-tag>
                  </div>
                  <div class="course-title">
                    <a :href="course?.url ?? '/'">
                      {{ course.name }}
                    </a>
                  </div>
                </div>
              </a-card>
          </div>
          <div v-else>
            <a-table
                rowKey="id"
                :columns="columns"
                :data-source="tableData"
                :scroll="{ x: 1600 }"
                :pagination="false"
                :loading="tableLoading"
                @change="handleTableChange"
                :table-layout="'fixed'"
            >
              <template #bodyCell="{ column, text, record }">
                <template v-if="column.dataIndex === 'name'">
                  <div class="course-title">
                    <a :href="record?.url ?? '/'" target="_blank">
                      {{ record.name }}
                    </a>
                  </div>
                </template>

                <template v-if="column.dataIndex === 'status'">
                  <a-tag color="green" v-if="record.status === 'finished'">
                    Завершен
                  </a-tag>
                  <a-tag class="yellow-tag" v-else-if="record.status === 'new'">
                    Не начат
                  </a-tag>
                  <a-tag class="blue-tag" v-else>
                    В процессе
                  </a-tag>
                </template>

                <template v-if="column.dataIndex === 'percent_completed'">
                  <div class="course-progress">
                    <a-progress :stroke-color="'#21AC0C'" :percent="text ?? 0" :format="percent => `${percent}%`" />
                  </div>
                </template>
              </template>

              <template #emptyText>
                <div class="no-data-wrapper">
                  <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>
                  <div class="no-data-text">
                    'Нет данных для отображения'
                  </div>
                </div>
              </template>
            </a-table>
          </div>
        </div>
        <div v-else-if="!tableData || cardsUpdating" class="loading-block">
          <a-spin/>
        </div>
      </div>

      <div class="pagination-block">
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total
                          ="total => `Всего ${total ?? 0} элементов`"
                      :total="courseActivityTotal ?? 0"
                      @change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {onBeforeMount} from "@vue/runtime-core";
  import {useStore} from "vuex";
  import {computed, ref} from "@vue/reactivity";
  import {MenuOutlined, PlusOutlined, ReloadOutlined, SettingOutlined} from "@ant-design/icons-vue";
  import NotFoundIcon from "@/assets/images/icons/no_data.svg";
  import coverA from '@/assets/images/default_course_image.png'
  import coverB from '@/assets/images/default_course_image_2.png'

  export default {
    components: {MenuOutlined, ReloadOutlined, PlusOutlined},
    setup() {
      const filterTypes = ['Карточками', 'Списком'];
      const selectedFilter = ref(filterTypes[0]);
      const courseActivity = computed(() => store.state.users.currentCourseActivity);
      const courseActivityTotal = computed(() => store.state.users.currentCourseActivityTotal);

      const store = useStore();

      const entitiesPerPage = ref(10);
      const currentPage = ref(1);
      const tableLoading = ref(true);
      const cardsUpdating = ref(false);

      const columns = computed(() => [
        {
          title: 'Название',
          dataIndex: 'name',
          width: 170,
          sorter: true,
        },
        {
          title: 'Статус',
          dataIndex: 'status',
          sorter: true,
          width: 100,
        },
        {
          title: 'Тип',
          dataIndex: 'type',
          sorter: false,
          width: 80,
        },
        {
          title: 'Завершить до',
          dataIndex: 'access_expired_at',
          sorter: true,
          width: 120,
        },
        {
          title: 'Прогресс',
          dataIndex: 'percent_completed',
          sorter: true,
          width: 140,
        },
        {
          title: 'Оценка',
          dataIndex: 'rate',
          sorter: false,
          width: 80,
        },
        {
          title: 'Пройдено',
          dataIndex: 'total_stages',
          sorter: false,
          width: 80,
        },
        {
          title: 'Текущий этап',
          dataIndex: 'current_stage',
          sorter: false,
          width: 180,
        },
        {
          title: 'Дата выдачи',
          dataIndex: 'activated_at',
          sorter: true,
          width: 120,
        },
        {
          title: 'Дата завершения',
          dataIndex: 'finished_at',
          sorter: true,
          width: 120,
        },
      ]);

      // пагинация
      const retrieveEntitiesPerPage = () => {
        let storageValue = localStorage.getItem('perPage');
        entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
      }

      const setEntitiesPerPage = (num) => {
        localStorage.setItem('perPage', num)
      }

      const handlePageChange = (current, perPage) => {
        if (entitiesPerPage.value !== perPage) {
          entitiesPerPage.value = perPage;
          setEntitiesPerPage(entitiesPerPage.value);
        }

        currentPage.value = current;
        fetchActivities();
      }

      //сортировка
      const sortState = ref({
        field: null,
        order: null,
      });

      const handleTableChange = (pagination, filter, sorter) => {
        sortState.value = {
          field: sorter?.field ?? null,
          order: sorter?.order ?? null,
        };

        fetchActivities();
      }

      const tableData = ref([]);

      const fetchActivities = () => {
        tableLoading.value = true;
        cardsUpdating.value = true;

        store.dispatch('users/getCourseActivity', {
          per_page: entitiesPerPage.value,
          page: currentPage.value,
          sort_field: sortState.value.field,
          sort_direction:
              sortState.value.order === 'ascend'
                  ? 'asc'
                  : sortState.value.order === 'descend'
                      ? 'desc'
                      : null,
        }).then(() => {
          tableData.value = courseActivity.value.map((el) => {
            const match = el.course_progress ? el.course_progress.match(/\((\d+)\s*\/\s*(\d+)\)\s*$/) : null;
            const stage = el.course_progress ? el.course_progress.replace(/\s*\([^)]*\)\s*$/, "").trim() : null;
            const progress = match ? `${match[1]} из ${match[2]}` : "";
            el.current_stage = stage;
            el.total_stages = progress;
            return el;
          })
        }).finally(() => {
          tableLoading.value = false;
          cardsUpdating.value = false;
        });
      }

      onBeforeMount(() => {
        retrieveEntitiesPerPage();
        fetchActivities();
      });

      return {
        NotFoundIcon,
        filterTypes,
        selectedFilter,
        courseActivity,
        courseActivityTotal,
        tableLoading,
        currentPage,
        entitiesPerPage,
        handlePageChange,
        handleTableChange,
        columns,
        coverA,
        coverB,
        tableData,
        cardsUpdating
      }
    }
  }
</script>

<style scoped lang="scss">

.card {
  min-height: 80vh;
}

.segment-block {
  margin-bottom: 20px;
}

.pagination-block {
  margin-left: auto;
  margin-top: auto;
}

.course-title {
  font-size: 14px;
  font-weight: 600;
}

.course-card-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    grid-template-columns: 1fr;
  }
}

:deep(.course-card .ant-card-body) {
  display: flex;
  column-gap: 16px;

  @media (max-width: $tablet-breakpoint) {
    flex-direction: column;
  }
}

.card-image-link {
  margin-bottom: 16px;

  img {
    width: 200px;
    object-fit: cover;
  }
}

.course-tag-wrapper {
  margin-bottom: 8px;
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

:deep(.ant-table-wrapper .course-title a) {
  color: var(--main-green);
  font-weight: 400;
}

.course-list {
  margin-bottom: 20px;
}

:deep(.card .ant-table-content) {
  min-height: 60vh;
}

.view-container {
  padding-top: 0;
}
</style>